<template>
  <div class="main-page" ref="scrollMenuRef">
    <!--  父菜单  -->
    <transition name="fade">
      <el-row v-if="navigateShow" class="menu-class" style="position: fixed;z-index: 1000;top: 0;">
        <div style="width: 100%;height: 100%;display: flex;">
          <div style="width: 50%;height: 100%;">
            <div class="company-logo" @click="toHome" />
          </div>
          <div style="width: 50%;height: 100%;text-align: right;">
            <i v-if="!menuShow" class="yk-icon-menu" style="margin: 17px 20px 0 0;font-size: 32px;color: #333333;" @click="showMenu" />
            <i v-else class="el-icon-close" style="margin: 17px 20px 0 0;font-size: 32px;color: #333333;" @click="closeMenu" />
          </div>
        </div>
      </el-row>
    </transition>
    <el-collapse v-show="mainShow" v-if="selMenu > -1" v-model="menuCollapse" class="header-collapse" :style="{top: navigateShow? '66px': '0'}">
      <el-collapse-item name="0">
        <template slot="title">
          <span style="margin-left: 3%;font-weight: bold;font-size: 14px;">{{menuList[selMenu].name}}</span>
          <span style="margin: 0 5px 0 5px;">/</span>
          <span v-if="selInd > -1">{{menuList[selMenu].data[selInd].name}}</span>
        </template>
        <div style="position: relative;top: 0;z-index: 999;">
          <el-menu style="width: 94%;margin: 0 0 0 3%;text-align: left;border-right: 0;border-top: 1px solid #aaa;" :default-active="selId"
                   unique-opened background-color="#fff" text-color="#303133" active-text-color="#00bf86" :key="timeStamp">
            <el-menu-item v-for="(item, i) in menuList[selMenu].data" :key="i" :index="item.id" class="header-menu-item" @click="clickMenu(i)">
              {{item.name}}
            </el-menu-item>
          </el-menu>
        </div>
      </el-collapse-item>
    </el-collapse>
<!--    &lt;!&ndash;  子菜单  &ndash;&gt;-->
<!--    <div v-show="popShow" class="pop-class" :style="{'left': (26 + 8 * hoverMenu) + '%'}" @mouseover.native="overPop" @mouseleave.native="leavePop">-->
<!--      <pop-over-down :data-list="dataList" @clickSub="clickSub" />-->
<!--    </div>-->
    <router-view v-show="mainShow" />
    <!--  页尾  -->
    <footer-page v-show="mainShow" />
    <el-drawer :visible.sync="menuShow" :with-header="false" :modal="false" :show-close="false" :withHeader="false" z-index="999" size="100%">
      <div style="padding-top: 66px;background-color: #f8f8f8;height: 100%;">
        <el-menu ref="drawerMenu" style="width: 94%;margin: 20px 0 0 3%;text-align: left;border-right: 0;"
                 unique-opened background-color="#f8f8f8" text-color="#303133" active-text-color="#303133">
          <el-submenu v-for="(item, i) in menuList" :key="i" :index="item.id" class="drawer-submenu-class">
            <span slot="title" style="font-weight: bold;font-size: 16px;">{{item.name}}</span>
            <el-menu-item v-for="(itemItem, j) in item.data" :key="j" :index="itemItem.id" class="drawer-menu-item" @click="clickDrawerMenu(i, j)">
              {{itemItem.name}}
            </el-menu-item>
          </el-submenu>
        </el-menu>
        <el-row style="position: absolute;bottom: 0;left: 0;z-index: 1000;padding: 16px 3% 20px 3%;font-size: 14px;color: #5e5e5e;line-height: 30px;text-align: left;width: 100%;background-color: #eeeeee;">
          <el-row style="width: 100%;font-size: 20px;height: 48px;font-weight: bold;">联 系 我 们</el-row>
          <el-row>电话：17720560059（张经理）</el-row>
          <el-row>备用：13733490447（张经理）</el-row>
          <el-row>座机：027-87003315</el-row>
          <el-row>邮箱：yukuitech@163.com</el-row>
          <el-row>地址：武汉东湖新技术开发区东信路11号武汉留学生创业园C4196</el-row>
        </el-row>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import PopOverDown from './PopOverDown'
import HomePage from './home/HomePage'
import IntroducePage from './introduce/IntroducePage'
import Product from './product/ProdPage'
import Solution from './solution/SoluPage'
import NewsPage from './news/NewsPage'
import FooterPage from './FooterPage'
export default {
  name: 'MainPage',
  components: { PopOverDown, HomePage, IntroducePage, Product, Solution, NewsPage, FooterPage },
  data() {
    return {
      mapOption: null,
      navigateShow: true,
      scroll: 1,
      scrollTop: 0,
      menuList: [
        {id: '2', name: '走进瑜岿', data: [{id: '21', name: '公司简介', parentId: '2', component: '/short_introduce'}, {id: '22', name: '企业文化', parentId: '2', component: '/culture'}, {id: '23', name: '资质荣誉', parentId: '2', component: '/honor'}, {id: '24', name: '核心团队', parentId: '2', component: '/team'}]},
        {id: '31', name: '软件产品', component: '/software', data: [{id: '311', name: '综合能源管理系统', parentId: '31', param: '311'}, {id: '312', name: '分布式光伏运维系统', parentId: '31', param: '312'}, {id: '313', name: '智慧配电系统', param: '313', parentId: '31'}, {id: '314', name: '预付费系统', param: '314', parentId: '31'}, {id: '315', name: '电气火灾监测系统', param: '315', parentId: '31'}]},
        {id: '32', name: '硬件产品', component: '/hardware', data: [{id: '321', name: '仪表类', param: '321', parentId: '32'}, {id: '322', name: '传感类', param: '322', parentId: '32'}, {id: '323', name: '智能类', param: '323', parentId: '32'}, {id: '324', name: '安防类', param: '324', parentId: '32'}]},
        {id: '4', name: '解决方案', component: '/solution', data: [{id: '41', name: '绿色高校', parentId: '4', param: '411'}, {id: '42', name: '绿色工厂', parentId: '4', param: '412'}, {id: '43', name: '智慧园区', parentId: '4', param: '413'}]},
        // {id: '5', name: '云平台', data: [{id: '51', name: '能耗监测云平台', parentId: '5', 'url': 'https://ems.yukui-tech.com'}, {id: '52', name: '配电运维云平台', parentId: '5', 'url': 'https://doms.yukui-tech.com'}]},
        // {id: '6', name: '加入瑜岿', data: []},
        {id: '7', name: '新闻资讯', component: '/news', data: [{id: '71', name: '公司新闻', parentId: '7', param: '71'}, {id: '72', name: '行业动态', parentId: '7', param: '72'}]}
        // {id: '8', name: '联系我们', data: []}
      ],
      dataList: [],
      selMenu: 0,
      selId: '1',
      selInd: -1,
      subMenu: '',
      subInd: '',
      subId: '',
      hoverMenu: 0,
      popShow1: false,
      popShow2: false,
      params: {},
      dict: {
        '/': '',
        '/short_introduce': {id: '2', subId: '21', subInd: 0}, '/culture': {id: '2', subId: '22', subInd: 1}, '/honor': {id: '2', subId: '23', subInd: 2}, '/team': {id: '2', subId: '24', subInd: 3},
        '/software': {id: '31', subId: ''},
        '/hardware': {id: '32', subId: ''},
        '/solution': {id: '4', subId: ''},
        '/news': {id: '7', subId: ''}
      },
      scrollTime: 0,
      changeTime: 0,
      menuCollapse: [],
      timeStamp: 0,
      menuShow: false,
      mainShow: true
    }
  },
  computed: {
    popShow() {
      return this.popShow1 || this.popShow2
    }
  },
  created() {
    this.handleRouteChange()
  },
  mounted() {
    // 监听浏览器/页面滚动条的滚动
    window.addEventListener('scroll', this.scrollContent)
  },
  watch: {
    $route: {
      handler(val) {
        this.handleRouteChange()
      },
      deep: true
    }
  },
  methods: {
    selectMenu(data) {
      if (data.data.length === 0) {
        if (this.selMenu === data.id) {
          location.reload()
        } else {
          this.selMenu = data.id
          this.$router.push(data.component)
        }
      }
    },
    overMenu(i, data) {
      if (data.data.length > 0) {
        this.dataList = data.data
        this.popShow1 = true
        this.hoverMenu = i
      }
    },
    leaveMenu(i) {
      let _this = this
      setTimeout(function () {
        if (i === _this.hoverMenu) {
          _this.popShow1 = false
          if (!(_this.popShow1 || _this.popShow2)) {
            _this.dataList = []
          }
        }
      }, 100)
    },
    overPop() {
      this.popShow2 = true
    },
    leavePop() {
      let _this = this
      setTimeout(function() {
        _this.popShow2 = false
      }, 100)
    },
    clickSub(data, i) {
      if (data.url) {
        window.open(data.url, '_blank')
      } else if (data.component) {
        this.popShow2 = false
        this.selMenu = data.parentId
        if (data.param) {
          this.$router.push({path: data.component, query: {'page': data.param}})
        } else if (data.component !== this.$route.path) {
          this.$router.push(data.component)
        }
      }
    },
    clickHome(selMenu, subId, params) {
      this.selMenu = selMenu
      this.subId = subId
      this.params = params
    },
    scrollContent() {
      // scrollTop为显示屏顶部与整个文档顶部间的距离
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let scroll = scrollTop - this.scrollTop
      this.scrollTop = scrollTop
      if (new Date().getTime() - this.changeTime < 500) {
        this.scroll = scroll
        return
      }
      if (scroll * this.scroll < 0 && new Date().getTime() - this.scrollTime < 1000) {
        this.scrollTime = new Date().getTime()
        this.scroll = scroll
        return
      }
      if (this.navigateShow === true && (scroll > 0 && scrollTop > 220)) {
        this.navigateShow = false
        this.changeTime = new Date().getTime()
      } else if (this.navigateShow === false && (scroll < 0 || scrollTop < 180)) {
        this.navigateShow = true
        this.changeTime = new Date().getTime()
      }
    },
    clickMenu(i) {
      if (this.menuList[this.selMenu].data[i].id === this.selId) {
        document.documentElement.scrollTop = 0
        if (this.$route.query.id) {
          this.menuCollapse = []
          this.$router.push({path: this.$route.path, query: {page: this.$route.query.page}})
        } else {
          location.reload()
        }
        return
      }
      this.menuCollapse = []
      this.selId = this.menuList[this.selMenu].data[i].id
      if (this.menuList[this.selMenu].data[i].param) {
        this.$router.push({path: this.menuList[this.selMenu].component, query: {'page': this.menuList[this.selMenu].data[i].param}})
      } else {
        this.$router.push({path: this.menuList[this.selMenu].data[i].component})
      }
    },
    handleRouteChange() {
      if (this.dict[this.$route.path] === '') {
        this.selMenu = -1
        this.selId = ''
        this.selInd = -1
        return
      }
      const selMenu = this.menuList.findIndex((item) => item.id === this.dict[this.$route.path].id)
      this.selMenu = selMenu
      console.log(this.$route.query.page)
      if (this.dict[this.$route.path].subId !== '') {
        document.documentElement.scrollTop = 0
        this.selInd = this.dict[this.$route.path].subInd
        this.selId = ''
        setTimeout(() => {
          this.selId = this.dict[this.$route.path].subId
          this.timeStamp = new Date().getTime()
        }, 200)
      } else if (this.$route.query.page) {
        document.documentElement.scrollTop = 0
        const selSub = this.menuList[selMenu].data.findIndex((item) => item.param === this.$route.query.page)
        this.selInd = selSub
        this.selId = ''
        setTimeout(() => {
          this.selId = this.menuList[selMenu].data[selSub].id
          this.timeStamp = new Date().getTime()
        }, 200)
      } else {
        this.$router.push({path: '/'})
      }
    },
    showMenu() {
      this.menuShow = true
      setTimeout(() => {
        this.mainShow = false
      }, 300)
    },
    closeMenu() {
      this.menuShow = false
      this.mainShow = true
    },
    clickDrawerMenu(i, j) {
      this.closeMenu()
      this.$refs.drawerMenu.close(this.menuList[i].id)
      if (this.menuList[i].data[j].param) {
        if (this.$route.path === this.menuList[i].component && this.$route.query.page === this.menuList[i].data[j].param) {
          document.documentElement.scrollTop = 0
          location.reload()
        } else {
          this.$router.push({path: this.menuList[i].component, query: {'page': this.menuList[i].data[j].param}})
        }
      } else {
        if (this.$route.path === this.menuList[i].data[j].component) {
          document.documentElement.scrollTop = 0
          location.reload()
        } else {
          this.$router.push({path: this.menuList[i].data[j].component})
        }
      }
    },
    toHome() {
      if (this.$route.path === '/') {
        document.documentElement.scrollTop = 0
        location.reload()
      } else {
        this.$router.push({path: '/'})
      }
    }
  }
}
</script>
<style>
  .header-menu-item {
    height: 40px !important;
    line-height: 40px !important;
    font-size: 14px;
    padding-left: 0 !important;
    margin-left: 5px !important;
    background-color: #fff !important;
    border-bottom: 1px solid #aaa !important;
  }
  .header-collapse {
    position: fixed;
    width: 100%;
    z-index: 998;
    transition: top 0.5s ease, bottom 0.4s ease;
  }
  .header-collapse .el-collapse-item__content {
    padding-bottom: 10px !important;
  }
  .drawer-submenu-class .el-submenu__title {
    padding-left: 5px !important;
    background-color: #f8f8f8 !important;
    border-bottom: 1px solid #aaa !important;
  }
  .drawer-submenu-class .el-submenu__title:hover {
    background-color: #f8f8f8 !important;
  }
  .drawer-menu-item {
    font-size: 14px;
    padding-left: 0 !important;
    margin-left: 10px !important;
    background-color: #f8f8f8 !important;
    border-bottom: 1px solid #aaa !important;
  }
  .fade-enter-active {
    animation: enter 0.5s ease;
  }
  .fade-leave-active {
    animation: leave 0.6s ease;
  }
  @keyframes leave {
    from{
      transform: translateY(1px);
    }
    to{
      transform: translateY(-100%);
    }
  }
  @keyframes enter {
    from{
      transform: translateY(-100%);
    }
    to{
      transform: translateY(0);
    }
  }
</style>
<style scoped>
  .main-page {
    width: 100%;
    height: 100%;
  }
  .menu-class {
    background: #ffffff;
    height: 66px;
    width: 100%;
    color: #000000;
    border-bottom: 1px solid #dddddd;
  }
  .company-logo {
    margin: 13px 0 0 10px;
    background-image: url("../assets/icon5.png");
    width: 116px;
    height: 40px;
    background-size: cover;
    cursor: pointer;
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 200px;
    margin: 0;
  }
  .pop-class {
    background-color: #ffffff;
    color: #000000;
    position: fixed;
    z-index: 1000;
    top: 74px;
    width: 9%;
    border: 1px solid #eeeeee;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainPage.vue